import {useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import Login from '../pages/login/Login';
import Dashboard from '../pages/dashboard/Dashboard';
import DemoRoutes from './DemoRoutes';
import DemoApiProductionRoutes from './DemoApiProductionRoutes';
import ViewUsers from '../components/user-management/view-users/ViewUsers';
import Users from '../pages/users/Users';
import PrivateRoute from './PrivateRoute';
import Layout from '../components/layout/Layout';
import EmptyState from '../components/page-not-found/EmptyState';
import {t} from 'i18next';
import ViewProjects from '../components/project-management/view-projects/ViewProjects';
import CreateProjectPage from '../components/project-management/create-project/CreateProjectPage';
import {useSelector} from 'react-redux';
import {RootState, store} from '../redux/store';
import ViewCodingForms from '../components/coding-forms-management/view-coding-forms/ViewCodingForms';
import Productions from '../pages/productions/Production';
import ProductionsAndExports from '../components/productions/ProductionsAndExports';
import Ingestion from '../pages/ingestion/Ingestion';
import ViewIngestion from '../components/ingestion/ViewIngestion';
import DocExplorer from '../pages/doc-explorer/DocExplorer';
import ReviewManagerDashboard from '../components/dashboard/review-manager-dashboard/ReviewManagerDashboard';
import ReviewerDashboard from '../components/dashboard/reviewer-dashboard/ReviewerDashboard';
import DomainAdminDashboard from '../components/dashboard/domain-admin-dashboard/DomainAdminDashboard';
import {ViewDocExplorer} from '../components/doc-explorer/ViewDocExplorer';
import CreateNewProduction from '../components/productions/create-new-production/CreateNewProduction';
import SessionSearch from '../pages/session-search/SessionSearch';
import ViewSessionSearch from '../components/session-search/ViewSessionSearch';
import Report from '../pages/reports/Report';
import ReportLandingPage from '../components/reports/ReportLandingPage';
import TallyLayout from '../components/reports/tally/layout/TallyLayout';
import DocumentViewer from '../pages/document-viewer/DocumentViewer';
import DocView from '../components/document-viewer/DocView';
import DataImports from '../pages/data-imports/DataImports';
import ViewDataImports from '../components/components/data-imports/ViewDataImports';
import DocList from '../components/doc-list/DocList';
import IngestionWizard from '../components/ingestion/IngestionWizard';
import SecurityGroup from '../pages/security-group/Securitygroup';
import ViewSecuritygroup from '../components/SecurityGroups/ViewSecuritygroup';
import ViewIngestionAnalytics from '../components/ingetion-analytics/ViewIngestionAnalytics';
import ViewSavedSearch from '../components/saved-search/ViewSavedSearch';
import IpRestriction from '../pages/ip-restriction/IpRestriction';
import ViewIpRestriction from '../components/ip-restriction';
import IngestionUnpulishDocuments from '../components/ingetion-unpublish-documents/IngetionUnpublishDocuments';
import CommentsList from '../components/comments-list/CommentsList';
import NewAssignment from '../components/assignments/new-assignment/NewAssignment';
import Assignments from '../pages/assignments/Assignments';
import ViewManageAssignments from '../components/assignments/ViewManageAssignments';
import AnnotationList from '../components/annotation-layer/AnnotationList';
import KeywordHighlightList from '../components/KeywordHighlighting/KeywordHighlightList';
import StandardReportsContainer from '../components/reports/standard-reports/StandardReportContainer';
import CommunicationExplorerOutlet from '../pages/communication-explorer/CommunicationExplorerOutlet';
import CommunicationExplorer from '../components/reports/communication-explorer/CommunicationExplorer';
import ProjectFieldList from '../components/project-field-list/ProjectFieldList';
import ConceptExplorer from '../components/reports/concept-explorer/ConceptExplorer';
import CategorizationOutlet from '../pages/categorization/CategorizationOutlet';
import ViewCategorization from '../components/categorization/ViewCategorization';
import BackgroundTask from '../pages/background-task/BackgroundTask';
import BatchRedaction from '../components/batch-redaction/BatchRedaction';
import {subscribeToGroup} from '../redux/middleware/signalrMiddleware';
import ManageClient from '../pages/client/ManageClient';
import ViewTagsFolders from '../components/tags-and-folders/ViewTagsFolders';
import BatchPrintMain from '../components/batch-print/BatchPrintMain';
import ViewRedactionTags from '../components/redaction-tags/ViewRedactionTags';
import ShareableLinksDownloadFlow from '../components/productions/create-new-production/shareable-links-download/ShareableLinksDownloadFlow';
import DownloadError from '../components/productions/create-new-production/shareable-links-download/DownloadError';
import DataExportContainer from '../components/reports/standard-reports/reports/data-export';
import SSOLoginCallBack from '../pages/login/SSOLoginCallBack';
import InactivityPopup from '../pages/inactivity-popup/InactivityPopup';
import AccessDenied from '../pages/access-denied/AccessDenied';
import Investigate from '../pages/ai-investigate/Investigate';
import {ViewAIInvestigate} from '../components/ai/investigate/ViewAIInvestigate';
import ViewAISummarize from '../components/ai/summarize/ViewAISummarize';
import ManageIndices from '../components/ai/investigate/manage-indices/ManageIndices';
import Review from '../pages/ai-review/Review';
import ViewAllReview from '../components/ai/review/ViewAllReview';
import Index from '../pages/index/Index';
import ManageIndicesDetail from '../components/ai/investigate/manage-indices/manage-indices-detail/ManageIndicesDetail';
import NewJobDetail from '../components/ai/review/create-job/new-job-detail/NewJobDetail';
import JobResults from '../components/ai/review/job-results/JobResults';
import {CreateCustomIndex} from '../components/ingetion-analytics/index-management/create-custom-index/CreateCustomIndex';
import IngestionApoHistory from '../components/ingestion/ingestion-apo/IngestionApoHistory';

const AppRoutes = () => {
  const isAuthenticated = !!useSelector(
    (state: RootState) => state.authenticatedUser.user
  );
  const userEmail = store.getState().authenticatedUser.user?.emailID;
  const projectId = store.getState().authenticatedUser.user?.projectId;
  const securityGroupId =
    store.getState().authenticatedUser.user?.securityGroupId;
  const roleId = store.getState().authenticatedUser.user?.roleId;

  useEffect(() => {
    if (userEmail) {
      store.dispatch(subscribeToGroup(userEmail));
    }
  }, [userEmail]);

  return (
    <BrowserRouter>
      <Routes>
        {/* Public Route */}
        <Route path="/login" element={<Login />} />
        <Route path="/callback" element={<SSOLoginCallBack />} />
        <Route path="/demo/*" element={<DemoRoutes />} />
        <Route path="/data/:key" element={<ShareableLinksDownloadFlow />} />
        <Route path="/prod/:key" element={<ShareableLinksDownloadFlow />} />
        <Route
          path="/Production/LinkExpired"
          element={<DownloadError isLinkExpired={true} />}
        />
        <Route
          path="/Production/DownloadError"
          element={<DownloadError isLinkExpired={false} />}
        />
        <Route
          path="/demoproductionapi/*"
          element={<DemoApiProductionRoutes />}
        />

        <Route path="/AccessDenied" element={<AccessDenied />} />

        {/* Private Routes (all wrapped inside Layout) */}
        <Route
          path="/"
          element={
            <PrivateRoute isAuthenticated={isAuthenticated}>
              <Layout />
              <InactivityPopup />
            </PrivateRoute>
          }
        >
          <Route index element={<Index />} />
          {/* <Route path="dashboard" element={<Dashboard />} /> */}
          <Route path="/User" element={<Users />}>
            <Route index element={<ViewUsers />} />
            <Route path="UserListView" element={<ViewUsers />} />
          </Route>
          <Route
            path="/Background/BackgroundTask"
            element={<BackgroundTask />}
          />
          <Route path="/Entity/Entity" element={<ManageClient />} />
          <Route path="/Project/Project" element={<ViewProjects />} />
          <Route path="/Comments/CommentsList" element={<CommentsList />} />
          <Route
            path="/BatchRedaction/BatchRedaction"
            element={<BatchRedaction />}
          />
          <Route
            path="ProjectFields/ProjectFieldsList"
            element={<ProjectFieldList />}
          />
          <Route
            path="/CodingForm/Create"
            element={<ViewCodingForms />}
          ></Route>
          <Route
            path="/Annotations/Annotations"
            element={<AnnotationList />}
          ></Route>
          <Route
            path="/Project/CreateProject"
            element={<CreateProjectPage />}
          />
          <Route path="/Project/EditProject" element={<CreateProjectPage />} />
          <Route
            path="/Keywords/Keywords"
            element={<KeywordHighlightList />}
          ></Route>
          <Route path="/demo/*" element={<DemoRoutes />} />
          <Route path="/ReviewerDashboard" element={<Dashboard />}>
            <Route
              index
              element={
                <ReviewerDashboard
                  key={JSON.stringify({projectId, securityGroupId})}
                />
              }
            />
            <Route
              path="index"
              element={
                <ReviewerDashboard
                  key={JSON.stringify({projectId, securityGroupId})}
                />
              }
            />
          </Route>
          <Route path="/DomainDashboard" element={<Dashboard />}>
            <Route index element={<DomainAdminDashboard />} />
            <Route path="DomainDashboard" element={<DomainAdminDashboard />} />
          </Route>
          <Route path="/Report/ReportsLanding" element={<Report />}>
            <Route index element={<ReportLandingPage />} />
          </Route>
          <Route path="/Report/Tally" element={<TallyLayout />} />
          <Route path="/Report/Tally/:ReportID" element={<TallyLayout />} />

          <Route
            path="/DataAnalysisReport/ConceptExplorer"
            element={<ConceptExplorer />}
          />
          <Route
            path="*"
            element={<EmptyState message={t('common.workInProgress')} />}
          />
          <Route
            path="/https://aurora-review.consilio.com/"
            element={<EmptyState message={t('common.workInProgress')} />}
          />
          <Route path="/dashboard" element={<Dashboard />}>
            <Route
              index
              element={
                <ReviewManagerDashboard
                  key={JSON.stringify({projectId, securityGroupId})}
                />
              }
            />
            <Route
              path="dashboard"
              element={
                <ReviewManagerDashboard
                  key={JSON.stringify({projectId, securityGroupId})}
                />
              }
            />
          </Route>

          <Route path="/docexplorer" element={<DocExplorer />}>
            <Route index element={<ViewDocExplorer />} />
            <Route
              path="explorer"
              element={<ViewDocExplorer key={roleId === 1 ? projectId : ''} />}
            />
          </Route>
          <Route path="/documentviewer" element={<DocumentViewer />}>
            <Route index element={<DocView />} />
            <Route path="docview" element={<DocView />} />
          </Route>
          <Route path="/Document/DocList" element={<DocList />}>
            <Route index element={<DocList />} />
            <Route path="doclist" element={<DocList />} />
          </Route>
          <Route path="/Production/Home" element={<Productions />}>
            <Route index element={<ProductionsAndExports />} />
            <Route path="New" element={<CreateNewProduction />} />
            <Route path="Edit" element={<CreateNewProduction />} />
          </Route>
          <Route path="/ingestion" element={<Ingestion />}>
            <Route index element={<ViewIngestion />} />
            <Route path="Home" element={<ViewIngestion />} />
            <Route path="Wizard" element={<IngestionWizard />} />
            <Route path="Apo" element={<IngestionApoHistory />} />
            <Route path="Copy/:ingestionId" element={<IngestionWizard />} />
            <Route path="Edit/:ingestionId" element={<IngestionWizard />} />
            <Route path="analytics" element={<ViewIngestionAnalytics />} />
            <Route path="UnPublish" element={<IngestionUnpulishDocuments />} />
            <Route
              path="Analytics/Indexing/CreateCustomIndex"
              element={<CreateCustomIndex />}
            />
          </Route>

          <Route path="/Search" element={<SessionSearch />}>
            <Route index element={<ViewSessionSearch />} />
            <Route path="Searches" element={<ViewSessionSearch />} />
          </Route>
          <Route path="/SecurityGroups" element={<SecurityGroup />}>
            <Route index element={<ViewSecuritygroup />} />
            <Route path="SecurityGroups" element={<ViewSecuritygroup />} />
          </Route>

          <Route
            path="/SavedSearch/SavedSearches"
            element={<ViewSavedSearch />}
          ></Route>

          <Route path="/ICE/Datasets" element={<DataImports />}>
            <Route index element={<ViewDataImports />} />
          </Route>
          <Route
            path="/DataAnalysisReport/:reportId/*"
            element={<StandardReportsContainer />}
          />
          <Route
            path="/Review/:reportId/*"
            element={<StandardReportsContainer />}
          />
          <Route
            path="/Report/:reportId"
            element={<StandardReportsContainer />}
          />
          <Route path="/Report/export/view" element={<DataExportContainer />} />
          <Route
            path="/Project/CreateIPRestriction"
            element={<IpRestriction />}
          >
            <Route index element={<ViewIpRestriction />} />
          </Route>
          <Route
            path="/DataAnalysisReport/CommunicationExplorerReport"
            element={<CommunicationExplorerOutlet />}
          >
            <Route index element={<CommunicationExplorer />} />
          </Route>
          <Route path="/Assignment" element={<Assignments />}>
            <Route index element={<ViewManageAssignments />} />
            <Route
              path="ManageAssignment"
              element={<ViewManageAssignments />}
            />
            <Route path="Create" element={<NewAssignment />} />
            <Route path="Edit" element={<NewAssignment />} />
          </Route>
          <Route path="/Proview/Proview" element={<CategorizationOutlet />}>
            <Route index element={<ViewCategorization />} />
          </Route>
          <Route
            path="/TagsAndFolders/TagsAndFolders"
            element={<ViewTagsFolders />}
          />
          <Route path="/BatchPrint" element={<BatchPrintMain />} />
          <Route path="/Redaction/Redaction" element={<ViewRedactionTags />} />

          <Route path="/AI/Investigate" element={<Investigate />}>
            <Route index element={<ViewAIInvestigate />} />
            <Route path="manage-indices" element={<ManageIndices />} />
            <Route
              path="manage-indices/details"
              element={<ManageIndicesDetail />}
            />
          </Route>
          <Route path="/AI/Review" element={<Review />}>
            <Route index element={<ViewAllReview />} />
            <Route path="/AI/Review/CreateJob" element={<NewJobDetail />} />
            <Route path="/AI/Review/JobResults" element={<JobResults />} />
          </Route>
          <Route path="/AI/Summarize" element={<ViewAISummarize />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRoutes;
